<template>
  <div>
    <el-row style="margin: 0 auto;">
      <el-col :span="22">
        <el-form ref="searchForm" :model="searchForm" style="display: flex;column-gap: 20px;">
          <el-form-item>
            <div>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                size="mini"
                :clearable="false"
                class="w300"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </el-form-item>
          
          <el-form-item v-if="!userInfo.shop_id">
            <el-select
                v-model="searchForm.shop_id"
                size="mini"
                value-key="shop_id"
                placeholder="请选择"
                filterable
              >
              <el-option
                v-for="item in shopList"
                :key="item.shop_id"
                :label="item.shop_name"
                :value="item.shop_id"
              />
            </el-select>
          </el-form-item>
        </el-form>  
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('1')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}各渠道总销售情况(新单+补单)</div>

            <div id="main11" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}各渠道订单人数(老客+新客)</div>

            <div id="main22" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <!-- <el-col :span="12"> -->
          <!-- <div class="chart-wrapper">
            <div id="main44" class="chart-content" />
          </div> -->
        <!-- </el-col> -->
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道新客进店数据(客资+进店)</div>

            <div id="main33" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道(新客)进店数+成交数对比</div>

            <div id="main66" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="0">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道总成交人数(老客+新客)</div>

            <div id="main55" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">
      <el-row>
          <el-col :span="24" class="table-container">
            <div class="chart-wrapper">
              <div class="table-title" style="margin-bottom: 2%;">{{name}}各渠道数据表（新客）</div>
          
              <el-table
                :data="newList"
                :default-sort = "{prop: 'proceeds_balance', order: 'descending'}"
                border
                size="small"
                :cell-style="$style.cellStyle"
                :row-class-name="tableRowClassName"
                :header-cell-style="$style.rowClass"
                >
                <el-table-column prop="name" label="来源" width="120"/>
                <el-table-column prop="proceeds_balance" label="渠道业绩" width="120" sortable/>
                <el-table-column label="渠道销售占比" width="150" sortable>   
                  <template slot-scope="{row}">
                    {{row.proceeds_rete}}%
                  </template>      
                </el-table-column>                  
                <el-table-column prop="gainCount" label="获客人数" width="120" sortable/>
                <el-table-column prop="bhGainCount" label="疤痕" sortable/>
                <el-table-column prop="ddGainCount" label="痘痘" sortable />
                <el-table-column prop="pfGainCount" label="皮肤" sortable />
                <el-table-column prop="enterCount" label="进店人数" width="120" sortable />
                <el-table-column prop="bhEnterCount" label="疤痕" sortable/>
                <el-table-column prop="ddEnterCount" label="痘痘" sortable />
                <el-table-column prop="pfEnterCount" label="皮肤" sortable />
                <el-table-column prop="cjCount" label="成交人数" width="120" sortable />
                <el-table-column prop="bhCjCount" label="疤痕" sortable/>
                <el-table-column prop="ddCjCount" label="痘痘" sortable />
                <el-table-column prop="pfCjCount" label="皮肤" sortable />
                <el-table-column label="成交转化率" width="150" sortable>
                  <template slot-scope="{row}">
                    {{row.cj_rate}}%
                  </template>        
                </el-table-column>     
              </el-table>
            </div>
          </el-col>
      </el-row>
    </div>
    
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title">{{name}}各渠道顾客订单人数数据(老客+新客)</div>

            <div id="main77" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}各渠道数据表（新客+老客）</div>
              <!-- show-summary -->
              <!-- :summary-method="calculateSummaries" -->
            <el-table
              :data="allList"
              border
              size="small"
              :default-sort = "{prop: 'perform', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="name" label="来源" width="150"/>
              <el-table-column label="渠道业绩" prop="perform" width="120" sortable>
              </el-table-column>
              <el-table-column label="渠道业绩占比" sortable>   
                <template slot-scope="{row}">
                  {{row.proceeds_rete}}%
                </template>      
              </el-table-column>     
              <el-table-column prop="cjCount" label="订单人数" sortable/>
              <el-table-column prop="bhCjCount" label="疤痕" sortable/>
              <el-table-column prop="ddCjCount" label="痘痘" sortable />
              <el-table-column prop="pfCjCount" label="皮肤" sortable/>
              <el-table-column prop="order_avg_price" label="客单价" sortable />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="charts-container">
      <el-row :gutter="20">
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">

            <!-- <div class="table-title">中医院品项销售表</div>
            <el-table
              :data="goodsList"
              height="600"
              size="small"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="name" label="品项名称" width="150"/>
              <el-table-column prop="pay_amount" label="销售本金"   sortable />
              <el-table-column prop="gift_amount" label="销售赠金"    sortable/>
              <el-table-column prop="num" label="销售数量" width="120"  sortable/>
              <el-table-column prop="cj_num" label="成交人数"  width="120" sortable/>
            </el-table> -->
            <div class="table-title" style="margin-bottom:3%;">{{name}}服务销售表</div>
            <el-table
              :data="serviceList"
              height="600"
              size="small"
              :default-sort = "{prop:'pay_amount', order: 'descending'}"
              :row-class-name="tableRowClassName"
              >
              <el-table-column prop="name" label="服务名称" width="220"/>
              <el-table-column prop="pay_amount" label="销售本金" align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金" align="center" sortable />
              <el-table-column prop="num" label="销售数量" width="120" align="center" sortable />
              <el-table-column prop="cj_num" label="成交人数"  width="120" align="center" sortable/>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}商品销售表</div>
            <el-table
              :data="goodsList"
              height="600"
              size="small"
              :row-class-name="tableRowClassName"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}"
              >
              <el-table-column prop="name" label="产品名称" width="220"/>
              <el-table-column prop="pay_amount" label="销售本金"  align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金"  align="center"  sortable />
              <el-table-column prop="num" label="销售数量"  width="120" align="center"  sortable/>
              <el-table-column prop="cj_num" label="成交人数" width="120"  align="center" sortable />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getChannelEnterCustomer,goodsTop,getChannelData,serviceTop,getLookShop  } from '@/api/sys'
import { mapGetters } from "vuex";
class Search {
  date = [];                  
  shop_id = '';

}

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
  },
    watch: {
    // 监听 tabIndex 变化，触发刷新
    tabIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getList(); // 调用数据加载方法
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),

    // tableData() {
    //   const res = this.list.reduce((res, item) => {
    //     item.maxnum = 0;
    //     if (item.list && item.list.length > 0) {
    //       const goods = item.list.map(goods => Object.assign({}, item, goods));
    //       goods[0].maxnum = item.list.length;
    //       res = res.concat(goods);
    //     } else {
    //       res.push(item);
    //     }
    //     return res;
    //   }, []);
    //   return res;
    // },
    // allList() {
    //   const res = this.list2.reduce((res, item) => {
    //     item.maxnum = 0;
    //     if (item.list && item.list.length > 0) {
    //       const goods = item.list.map(goods => Object.assign({}, item, goods));
    //       goods[0].maxnum = item.list.length;
    //       res = res.concat(goods);
    //     } else {
    //       res.push(item);
    //     }
    //     return res;
    //   }, []);
    //   return res;
    // },
  },
  data() {
    const that = this; 
    return {
      searchForm: new Search(),
      name:'',
      cjNum:0,
      cjAmount:0,
      shopList:[],
      list:[],
      list2:[],
      newList:[],
      allList:[],
      goodsList:[],
      serviceList:[],
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      chart6: null,
      chart7: null,
      // pickerOptions: {
      //   onPick: ({ maxDate, minDate }) => {
      //     if (minDate) {
      //       that.searchForm.date[0] = minDate.getTime(); 
      //     }
      //     if (maxDate) {
      //       that.searchForm.date[1] = maxDate.getTime(); 
      //     }
      //   },
      //   disabledDate: (time) => {
      //     const currentTime = time.getTime();
      //     const now = Date.now(); 
      //     if (that.searchForm.date[0]) {
      //       const startDate = new Date(that.searchForm.date[0]);
            
      //       const twoMonthsLater = new Date(startDate);
      //       twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
            
      //       const twoMonthsEarlier = new Date(startDate);
      //       twoMonthsEarlier.setMonth(twoMonthsEarlier.getMonth() - 2);
            
      //       return currentTime < twoMonthsEarlier || 
      //             currentTime > twoMonthsLater || 
      //             currentTime > now;
      //     } else {
      //       const twoMonthsAgo = new Date(now);
      //       twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);
      //       return currentTime > now || currentTime < twoMonthsAgo;
      //     }
      //   },
      // },
      pickerOptions: {
        // 选择器范围：当前时间往前推两个月到当前时间
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            that.searchForm.date[0] = minDate.getTime(); 
          }
          if (maxDate) {
            that.searchForm.date[1] = maxDate.getTime(); 
          }
        },
        disabledDate: (time) => {
          console.log(time,"time")
          const year = time.getFullYear();
          if (year <= 2024) {
            return true;
          }
          const currentTime = time.getTime();
          const now = Date.now(); 
          console.log(that.searchForm.date[0],"that.searchForm.date[0]")
          if (that.searchForm.date[0]) {
            const startDate = new Date(that.searchForm.date[0]);
            const twoMonthsLater = new Date(startDate);
            twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
            const twoMonthsEarlier = new Date(startDate);
            twoMonthsEarlier.setMonth(twoMonthsEarlier.getMonth() - 2);
            return currentTime < twoMonthsEarlier || currentTime > twoMonthsLater || currentTime > now;
          }
        }
      }
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
      // this.searchForm.date = this.generateDefaultThreeMonths();
      this.getList();
      window.addEventListener('resize', this.handleResize);
    });
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart1) this.chart1.dispose();
    if (this.chart2) this.chart2.dispose();
    if (this.chart3) this.chart3.dispose();
    if (this.chart4) this.chart4.dispose();
    if (this.chart5) this.chart5.dispose();
    if (this.chart6) this.chart6.dispose();
    if (this.chart7) this.chart7.dispose();
  },
  
  methods: {
    // generateDefaultThreeMonths() {
    //   const now = new Date();
    //   const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    //   const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    //   const format = (date) => {
    //     return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    //   };
    //   return [format(monthStart), format(monthEnd)];
    // },
       // 自定义合计计算逻辑
    calculateSummaries(param) {
      const { columns, data } = param;
      const summaries = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          summaries[index] = "合计";
          return;
        }

        const prop = column.property;
        const label = column.label;

        if (label === "渠道业绩占比") {
          summaries[index] = "100%";
          return;
        }

    const needSumProps = [
        "perform", 
        "cjCount", 
        "bhCjCount", 
        "ddCjCount", 
        "pfCjCount",
        "order_avg_price"
      ];

      if (needSumProps.includes(prop)) {
        const total = data.reduce((sum, item) => {
          const value = Number(item[prop]) || 0; 
          return sum + value;
        }, 0);

        if (prop === "perform" || prop === "order_avg_price") {
          summaries[index] = total.toFixed(2); // 保留两位小数
        } else {
          summaries[index] = Math.round(total).toString(); // 取整数（四舍五入）
        }
        
        return;
      }

        summaries[index] = "";
      });

      return summaries;
    },



    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.maxnum,
          colspan: 1
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    changeTab(index){
      // this.tabIndex = index
    },
    // 初始化图表实例
    initCharts() {
      const main11Dom = document.getElementById('main11');
      const main22Dom = document.getElementById('main22');
      const main33Dom = document.getElementById('main33');
      // const main44Dom = document.getElementById('main44');
      const main55Dom = document.getElementById('main55');
      const main66Dom = document.getElementById('main66');
      const main77Dom = document.getElementById('main77');


      
      // 确保容器存在再初始化
      if (main11Dom) this.chart1 = echarts.init(main11Dom);
      if (main22Dom) this.chart2 = echarts.init(main22Dom);
      if (main33Dom) this.chart3 = echarts.init(main33Dom);
      // if (main44Dom) this.chart4 = echarts.init(main44Dom);
      if (main55Dom) this.chart5 = echarts.init(main55Dom);
      if (main66Dom) this.chart6 = echarts.init(main66Dom);
      if (main77Dom) this.chart7 = echarts.init(main77Dom);


    },
    
    // 统一处理resize
    handleResize() {
      if (this.chart1) this.chart1.resize();
      if (this.chart2) this.chart2.resize();
      if (this.chart3) this.chart3.resize();
      // if (this.chart4) this.chart4.resize();
      if (this.chart5) this.chart5.resize();
      if (this.chart6) this.chart6.resize();
      if (this.chart7) this.chart7.resize();

    },
    
    async getList() {
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });

      try {
        const shopRes = await getLookShop();
        this.shopList = shopRes.data || []; 

        if (this.userInfo?.shop_id) { 
          this.searchForm.shop_id = this.userInfo.shop_id;
        } else if( this.searchForm.shop_id == ''){
            this.searchForm.shop_id = this.shopList.length > 0 
            ? this.shopList[0].shop_id || ''  
            : '';  
        } else {
          this.searchForm.shop_id = this.searchForm.shop_id ;
        }

        const commonParams = {
          start_time: this.searchForm.date[0] || '',
          end_time: this.searchForm.date[1] || '',
          shop_id: this.searchForm.shop_id
        };

        const [goodsRes, serviceRes, channelCusRes, channelDataRes] = await Promise.all([
          goodsTop(commonParams),
          serviceTop(commonParams),
          getChannelEnterCustomer(commonParams),
          getChannelData(commonParams)
        ]);

        this.goodsList = goodsRes.data || [];

        this.serviceList = serviceRes.data || [];

        this.list = channelCusRes.data || [];
        const firstCusItem = this.list[0] || {}; 
        this.newList = firstCusItem.list || [];  
        this.name = firstCusItem.shop_name || '未知店铺';
        this.echarts1(this.newList.slice(0, -1)); 

        this.list2 = channelDataRes.data || [];
        const firstChannelItem = this.list2[0] || {}; 
        this.allList = firstChannelItem.list || [];  
        
        if (this.allList.length > 0) {
          const lastItem = this.allList[this.allList.length - 1];
          this.cjAmount = Number(lastItem.perform) || 0; 
          this.cjNum = Number(lastItem.cjCount) || 0;
        } else {
          this.cjAmount = 0;
          this.cjNum = 0;
        }
        this.echarts2(this.allList.slice(0, -1));

      } catch (err) {
        console.error("数据加载失败：", err);
        this.$message.error("数据加载失败，请重试");
        this.goodsList = [];
        this.serviceList = [];
        this.newList = [];
        this.allList = [];
      } finally {
        loading.close();
        this.$nextTick(() => {
          this.handleResize();
        });
      }
    },
    // 新客+老客
    echarts2(jine) {
      if (!this.chart1) return;
      if (!this.chart2) return;
      if (!this.chart7) return;
      const baseColors = [
          '#2767FC', '#3491FA', '#4DA6FF', '#69B1FF', // 蓝色系（浅→深）
          '#E49119', '#F3C669', '#FFD787', '#FFE8B3', // 橙色系
          '#36CFC9', '#5AD8A6', '#8AE29E', '#B7F0B3', // 绿色系
          '#D93F30', '#F56C6C', '#FF9E99', '#FFC7C2', // 红色系
          '#722ED1', '#9370DB', '#B39DDB', '#D8C9F0', // 紫色系
          '#86909C', '#A8B0BD', '#C9CDD4', '#E5E6EB'  // 灰色系
      ];
      const professionalColors1 = ['#6A98E4', '#2767FC', '#85D4EE', '#EB5B73','#FFA06C','#376473','#31c5e9'];
      const professionalColors2 = ['#9FE6B8', '#32C5E9', '#2767FC', '#9D96F5','#E062AE','#FFA06C','#FEDB65'];

     const option1 = {
        color: baseColors,
        title: {
          text: this.cjAmount,
          textStyle: {
            fontSize: 32,
            color: '#2767FC',
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}元 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: jine.filter(item => item.proceeds_balance !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false // 图例隐藏，不影响核心功能
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              formatter: function(params) {
                // 双重保险：即使有漏网的0值，也隐藏标签
                if (params.value === 0) {
                  return '';
                }
                return `${params.name}: ${params.value}元 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            // 关键：过滤掉proceeds_balance为0的数据，不渲染对应的扇区
            data: jine
              .filter(item => item.proceeds_balance !== 0) // 只保留非0值数据
              .map(item => ({
                name: item.name,
                value: item.proceeds_balance
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
    const option2 = {
        color: baseColors,
        title: {
          text: this.cjNum,
          textStyle: {
            fontSize: 32, 
            color: '#2767FC', 
            fontWeight: 'bold' 
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          // 双重保险：0值不显示tooltip
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}人 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          // 图例同步过滤0值（当前隐藏，后续开启时保持与饼图数据一致）
          data: jine.filter(item => item.cjCount !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              // 双重保险：0值不显示标签（过滤后理论无0值，防意外）
              formatter: function(params) {
                if (params.value === 0) {
                  return '';
                }
                return `${params.name}: ${params.value}人 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            // 关键：过滤掉cjCount为0的数据，不渲染对应扇区
            data: jine.filter(item => item.cjCount !== 0).map(item => ({
                name: item.name,
                value: item.cjCount // 人数数据（确保字段正确）
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      const option7 = {
        title: {
          show:false,
          text: `${this.name}各渠道顾客成交情况(新客+老客)`,
          left: 'center',
          textStyle: { 
            fontSize: 24,
            background:'red'

          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center', // 缩小右侧间距，避免遮挡
          top: '4%',
          data: ['疤痕', '痘痘', '皮肤'],
          textStyle: {  }
        },
        grid: {
          left: '1%',
          right: '1%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name), // 渠道名称数组
          axisLine: { lineStyle: {} },
          axisLabel: { 
            // rotate: 45,  // 标签旋转，避免重叠
            interval: 0  // 强制显示所有标签（配合滚动）
          },
          // 核心：添加滚动条配置
          scrollbar: {
            show: true,  // 开启滚动条
            height: 8,   // 滚动条高度（单位：px）
            bottom: 5,   // 滚动条距离底部的距离（避免与坐标轴重叠）
            backgroundColor: 'transparent', // 背景透明
            handleColor: '#2767FC',         // 滚动条滑块颜色
            handleSize: 15,                 // 滑块大小
            showDataShadow: false,          // 关闭数据阴影
            showDetail: false               // 不显示详细信息
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            minInterval: 1,
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '疤痕',
            type: 'bar',
            data: jine.map(item => item.bhCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },
          {
            name: '痘痘',
            type: 'bar',
            data: jine.map(item => item.ddCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' }, // 橙色系区分
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },
          {
            name: '皮肤',
            type: 'bar',
            data: jine.map(item => item.pfCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          }
        ]
      };
      this.chart1.setOption(option1);
      this.chart2.setOption(option2);
      this.chart7.setOption(option7);
    },
    echarts1(jine) {
      if (!this.chart3) return;
      // if (!this.chart4) return;
      if (!this.chart5) return;
      if (!this.chart6) return;
     
      const option3 = {
        title: {
          show:false,
          text: `${this.name}各渠道新客进店数据(客资+进店)`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left:'center',
          top: '4%',
          data: ['获客数', '成交数', '进店数'],
          textStyle: {  }
        },
        grid: {
          left: '1%',
          right: '1%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: { } },
          // axisLabel: { rotate: 45, interval: 0 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '获客数',
            type: 'bar',
            data: jine.map(item => item.gainCount), // 明确字段
            barWidth: '20%',
            barCategoryGap: '30%', // 增大组间间距
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9 ' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },
      
          {
            name: '成交数',
            type: 'line',
            data: jine.map(item => item.cjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#78DF69' }, // 橙色系区分
                { offset: 1, color: '#78DF69' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },    
          {
            name: '进店数',
            type: 'bar',
            data: jine.map(item => item.enterCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ADBEDB' },
                { offset: 1, color: '#ADBEDB' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },
        ]
      };
      const option4 = {
        title: {
          show:false,
          text: `${this.name}各渠道进店数据`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          top: '4%',
          right: 'center', // 缩小右侧间距，避免遮挡
          data: ['获客数', '进店数'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {  } },
          // axisLabel: { rotate: 45, interval: 0 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: { } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '获客数',
            type: 'bar',
            data: jine.map(item => item.gainCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },
          {
            name: '进店数',
            type: 'bar',
            data: jine.map(item => item.enterCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          }
        ]
      };
      const option5 = {
        title: {
          show:false,
          text: `${this.name}各渠道(新客)成交数`,
          left: 'center',
          textStyle: { 
            fontSize: 24

          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center', // 缩小右侧间距，避免遮挡
          top: '4%',
          data: ['疤痕', '痘痘', '皮肤'],
          textStyle: {  }
        },
        grid: {
          left: '5%',
          right: '5%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name), // 渠道名称数组
          axisLine: { lineStyle: {} },
          axisLabel: { 
            // rotate: 45,  // 标签旋转，避免重叠
            interval: 0  // 强制显示所有标签（配合滚动）
          },
          // 核心：添加滚动条配置
          scrollbar: {
            show: true,  // 开启滚动条
            height: 8,   // 滚动条高度（单位：px）
            bottom: 5,   // 滚动条距离底部的距离（避免与坐标轴重叠）
            backgroundColor: 'transparent', // 背景透明
            handleColor: '#2767FC',         // 滚动条滑块颜色
            handleSize: 15,                 // 滑块大小
            showDataShadow: false,          // 关闭数据阴影
            showDetail: false               // 不显示详细信息
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '疤痕',
            type: 'bar',
            stack : "堆叠",
            data: jine.map(item => item.bhCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },
          {
            name: '痘痘',
            type: 'bar',
            data: jine.map(item => item.ddCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' }, // 橙色系区分
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          },
          {
            name: '皮肤',
            type: 'bar',
            data: jine.map(item => item.pfCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: '{c}人'   
            }
          }
        ]
      };
      const option6 ={
          title: {
            show:false,
            text: `${this.name}各渠道(新客)进店数与成交数对比`,
            left: 'center',
            textStyle: { fontSize: 24 }
          },
          tooltip: {
            trigger: 'axis',       
            textStyle: {
              align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
            },
            axisPointer: { type: 'shadow' },
            formatter: function(params) {
              let result = `${params[0].name}<br/>`;
              params.forEach(item => {
                const unit = item.seriesName.includes('转化率') ? '%' : '人';
                result += `${item.seriesName}: ${item.value}${unit}<br/>`;
              });
              return result;
            }
          },
          legend: {
            orient: 'horizontal',
            right: 'center',
            top: '4%',
            data: [
              '进店-疤痕','进店-痘痘','进店-皮肤',
              '成交-疤痕','成交-痘痘','成交-皮肤'
            ],
            textStyle: { fontSize: 12 },
            formatter: function(name) {
              return name === '\n' ? '' : (name.includes('成交') ? '成交：' : '进店：') + name.split('-')[1];
            }
          },
          grid: {
            left: '1%',
            right: '1%',
            bottom: '1%',
            top: '12%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: jine.map(item => item.name),
            axisLine: { lineStyle: {} },
            axisLabel: { 
              interval: 0  
            }
          },
          yAxis: [
            {
              type: 'value',
              name: '数量（人）',
              nameTextStyle: {},
              axisLine: { lineStyle: {} },
              axisLabel: { formatter: '{value}人' },
              splitLine: { lineStyle: { color: '#CDD3E2' } }
            }
          ],
          series: [
            {
              name: '进店-疤痕',
              type: 'bar',
              stack: '进店组',
              data: jine.map(item => item.bhEnterCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(81, 182, 246, 0.8)' }, // 浅天蓝（比成交蓝更亮）
                  { offset: 1, color: 'rgba(33, 150, 243, 0.8)' }  // 深天蓝（比成交蓝稍浅）
                ]),
                borderRadius: [0, 0, 4, 4]
              },
              label: {
               show:true,
                fontSize: 12,
                color: 'white' ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }

              }
            },
            {
              name: '进店-痘痘',
              type: 'bar',
              stack: '进店组',
              data: jine.map(item => item.ddEnterCount),
              barWidth: '25%',
              itemStyle: {
                // 对应成交-痘痘的蓝灰色系 → 更雅致的青灰色渐变（避免沉闷）
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#ADBEDB' },
                    { offset: 1, color: '#ADBEDB' } // 深青灰（比成交蓝灰更暖）
                ]),
                borderRadius: [0, 0, 4, 4]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white' ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }

              }
            },
            {
              name: '进店-皮肤',
              type: 'bar',
              stack: '进店组',
              data: jine.map(item => item.pfEnterCount),
              barWidth: '25%',
              itemStyle: {
                // 对应成交-皮肤的橙色系 → 更温暖的琥珀色渐变（不刺眼，显柔和）
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(252, 211, 77, 0.8)' }, // 浅琥珀（比成交橙更亮）
                  { offset: 1, color: 'rgba(245, 158, 11, 0.8)' }  // 深琥珀（比成交橙稍浅）
                ]),
                borderRadius: [0, 0, 4, 4]
              },
              label: {
               show: true,
                fontSize: 12,
                color: 'white',
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            },
            {
              name: '成交-疤痕',
              type: 'bar',
              stack: '成交组',
              data: jine.map(item => item.bhCjCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#E91E63' },
                  { offset: 1, color: '#E91E63' }
                ]),
                borderRadius: [4, 4, 0, 0]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white'  ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            },
            {
              name: '成交-痘痘',
              type: 'bar',
              stack: '成交组',
              data: jine.map(item => item.ddCjCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2196F3' },
                  { offset: 1, color: '#2196F3' }
                ]),
                borderRadius: [4, 4, 0, 0]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white',
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            },
            {
              name: '成交-皮肤',
              type: 'bar',
              stack: '成交组',
              data: jine.map(item => item.pfCjCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#00BCD4' },
                  { offset: 1, color: '#00BCD4' }
                ]),
                borderRadius: [4, 4, 0, 0]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white' ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            }
          ]
        };

      this.chart3.setOption(option3);
      // this.chart4.setOption(option4);
      this.chart5.setOption(option5);
      this.chart6.setOption(option6);



    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex%2 == 0) {
        return 'ou-row';

      } else{
        return 'ji-row';

      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__footer-wrapper .el-table__cell {
  text-align: center !important;
  font-weight: bold;
}
::v-deep .el-table tr.ou-row {
  background-color: #EEF6FF;
}
::v-deep .el-table tr.ji-row {
  background-color: #D4E6F4;
}

 ::v-deep .el-table__cell {
  //  background: #EEF6FF !important;
   color: #2861C0 !important;
   color: #333333 !important;
   color: #2861C0 !important;

   font-weight: 600;
   font-size: 15px;
 }
  // ::v-deep .el-table__body {
  //   td:nth-child(1) { // 第2列
  //     color: #000000 !important;
  //   }
  // }

::v-deep .el-table__header .el-table__cell {
  background: #C2DBF9  !important; /* 与内容区背景统一 */
  color: #000000 !important;
}

::v-deep .el-table__row:hover > .el-table__cell {
  // background: #C2DBF9  !important; /* 略浅的hover背景，保持一致性 */
}
.flex{
  color: #333;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    font-size: 1.2rem;
    padding: 1.5rem 3rem;
    border: 1px solid #EDF2FF;
    border-radius: 0.5rem;
    box-shadow: inset 0 0 0.5rem #EDF2FF;
    background-color: #EDF2FF;
    overflow: hidden;
    text-align: center;
    span{
      display: block; 
      font-size: 2.5rem;
      line-height: 3rem;
      margin-bottom: 0.3rem;
    }
  }
}
/* 图表容器样式优化 */
.charts-container {
  margin: 20px 0;
 text-align: center;
  .table-title{
    display: inline-block; 
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    background: #79A7FE;
    // background: #C2DBF9;
  //  background: linear-gradient(270deg, #33bea7 0%, #60e0c5 50%, #88f0e1 100%);
    padding:1rem ;
    border-radius: 1rem;

  }
}

.chart-wrapper {
  width: 100%;
  box-sizing: border-box; /* 确保padding不会增加元素总宽度 */
  background: #EDF2FF;
  padding: 2%;
  box-sizing: border-box;
  border-radius: 3rem;

}

.chart-content {
  width: 100%;
  height: 540px; /* 固定高度，确保初始化时有明确尺寸 */
}
</style>
